import { routes } from '../constants';
import { isAIToolsPagePath } from './isAIToolsPagePath';
import useRouter from './useRouter';

const otherMukibudeRouteRoots = [routes.myContents.root, routes.aiAssistantHistory.root];

const useIsMukibudeRoute = (): boolean => {
	const {
		match: {
			location: { pathname },
		},
	} = useRouter();

	return (
		isAIToolsPagePath(pathname) ||
		otherMukibudeRouteRoots.some(
			(root) => pathname === `/${root}` || pathname.startsWith(`/${root}/`)
		)
	);
};

export default useIsMukibudeRoute;
